import { Link } from "wouter";
import { Bell } from "lucide-react";
import { FOCUS_RING } from "../../lib/focusRing";
import { useNotifications } from "../../lib/api/useNotifications";

/**
 * Header notification bell with a live unread badge (slice E). Reads the shared
 * notifications query (polled every 30s) so the badge tracks the center page in
 * real time. Links to /notifications.
 */
export function NotificationBell() {
  const { data } = useNotifications();
  const unread = data?.unreadCount ?? 0;
  const hasUnread = unread > 0;
  const badge = unread > 9 ? "9+" : String(unread);

  return (
    <Link
      href="/notifications"
      aria-label={hasUnread ? `Notifications, ${unread} unread` : "Notifications"}
      className={`relative inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-sky-200 bg-white text-sky-700 shadow-soft transition hover:bg-sky-50 ${FOCUS_RING}`}
    >
      <Bell className="h-4 w-4" aria-hidden />
      {hasUnread && (
        <span
          aria-hidden
          className="absolute -right-0.5 -top-0.5 inline-flex h-4 min-w-[1rem] items-center justify-center rounded-full bg-red-500 px-1 text-[10px] font-bold leading-none text-white ring-2 ring-white"
        >
          {badge}
        </span>
      )}
    </Link>
  );
}
